import * as swcHelpers from '@swc/helpers';
import { dynamicLoadPhoneNumberInput } from './dynamic-load-phone-number-input.js';

const getParsePhoneNumber = function() {
    var _ref = swcHelpers.asyncToGenerator(function*() {
        const { parsePhoneNumber  } = yield dynamicLoadPhoneNumberInput();
        return parsePhoneNumber;
    });
    return function getParsePhoneNumber() {
        return _ref.apply(this, arguments);
    };
}();

export { getParsePhoneNumber };
//# sourceMappingURL=get-parse-phone-number.js.map
